export default "__VITE_ASSET__DwvN5vmr__"